import type { Survey } from 'app/common/types/surveys'
import type SimpleDate from 'app/common/classes/simple-date'

export enum SurveysTableColumn {
  Title = 'title',
  Settlement = 'settlement',
  District = 'district',
  KindLocation = 'kindLocation',
  Actions = 'actions',
  Institution = 'institution',
  Period = 'period',
  Results = 'results',
}

export type SurveysTableDataItem = {
  survey: Survey
  id: string
  dateFrom: SimpleDate | null
  dateTo: SimpleDate | null
  positive: number
  negative: number
  [SurveysTableColumn.Title]: string
  [SurveysTableColumn.Settlement]: string
  [SurveysTableColumn.District]: string
  [SurveysTableColumn.KindLocation]: string
  [SurveysTableColumn.Institution]: string
  [SurveysTableColumn.Period]: string
  [SurveysTableColumn.Actions]: string
  [SurveysTableColumn.Results]: string
}

export const surveysTableDataArrange = [
  SurveysTableColumn.Title,
  SurveysTableColumn.KindLocation,
  SurveysTableColumn.Settlement,
  SurveysTableColumn.District,
  SurveysTableColumn.Institution,
  SurveysTableColumn.Period,
  SurveysTableColumn.Results,
  SurveysTableColumn.Actions,
]

export const surveysTableHeaders: Array<Record<SurveysTableColumn, string>> = [
  {
    [SurveysTableColumn.Title]: 'Наименование',
    [SurveysTableColumn.Settlement]: 'Населенный пункт',
    [SurveysTableColumn.District]: 'Район',
    [SurveysTableColumn.KindLocation]: 'Вид опроса/Место опроса',
    [SurveysTableColumn.Institution]: 'Заведение',
    [SurveysTableColumn.Period]: 'Период опроса',
    [SurveysTableColumn.Results]: 'Результаты',
    [SurveysTableColumn.Actions]: '',
  },
]

export const surveysTableCellProps = {
  [SurveysTableColumn.Title]: { alignLeft: true },
  [SurveysTableColumn.Settlement]: { alignLeft: true },
  [SurveysTableColumn.District]: { alignLeft: true },
  [SurveysTableColumn.KindLocation]: { alignLeft: true },
  [SurveysTableColumn.Institution]: { alignLeft: true },
  [SurveysTableColumn.Period]: { alignLeft: true },
  [SurveysTableColumn.Results]: { alignLeft: true },
  [SurveysTableColumn.Actions]: { alignLeft: true, stripPadding: true },
}

export const surveysToTableData = (surveys: Array<Survey>): Array<SurveysTableDataItem> => surveys.map((survey) => {
  return {
    survey,
    id: survey.id,
    dateFrom: survey.startsOn,
    dateTo: survey.endsOn,
    positive: survey.results.positive,
    negative: survey.results.negative,
    [SurveysTableColumn.Title]: survey.title,
    [SurveysTableColumn.Settlement]: survey.scope.cityName || 'Все',
    [SurveysTableColumn.District]: survey.scope.districtName || 'Все',
    [SurveysTableColumn.KindLocation]: '',
    [SurveysTableColumn.Actions]: '',
    [SurveysTableColumn.Institution]: survey.scope.schoolName || 'Все',
    [SurveysTableColumn.Period]: '',
    [SurveysTableColumn.Results]: '',
  }
})
